var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { office, agent, property_type, builder_branding, isPhone, listing_provider } = options; 
__p+='\n<div class="qv-branding qv-ab-promo-branding">\n  <div class="clearfix">\n    <div class="essentials-branding branding-wrapper">\n      <div class="component_business-card business-card-md '+
((__t=( office.photo_attribution.photo? '' : 'no-media' ))==null?'':__t)+
'  no-media-xs ">\n        ';
 if(listing_provider && listing_provider.agent_photo) { 
__p+='\n          <div class="media">\n            <div class="branding-photo agent-photo media-img-wrapper hidden-qv-xs media-img-wrapper">\n              <img src="'+
((__t=( listing_provider.agent_photo ))==null?'':__t)+
'" alt="This listing is presented by '+
((__t=( listing_provider.agent_name ))==null?'':__t)+
'" class="absolute-centering">\n            </div>\n          </div>\n        ';
 } 
__p+='\n        ';
 if(office && office.photo_attribution && office.photo_attribution.photo) { 
__p+='\n          <div class="media">\n            <div class="branding-photo office-photo hidden-qv-xs media-img-wrapper">\n              <img src="'+
((__t=( office.photo_attribution.photo ))==null?'':__t)+
'" alt="This listing is presented by '+
((__t=( office.details.name ))==null?'':__t)+
'" class="absolute-centering">\n            </div>\n          </div>\n        ';
 } 
__p+='\n        <div class="content ellipsis">\n          ';
 if(agent && agent.details && agent.details.name) { 
__p+='\n            <span itemscope itemtype="http://schema.org/RealEstateAgent" class="agent-name font-size-small">\n              <span class="hidden-qv-xs">Presented by: </span>\n              <span class="visible-qv-xs-inline">By </span>\n              <span class="qv-branding-link" itemprop="name" data-label="branding-agent-name">'+
((__t=( agent.details.name ))==null?'':__t)+
' | </span>\n              <meta itemprop="image" content="'+
((__t=( agent.photo_attribution.link ))==null?'':__t)+
'">\n            </span>\n          ';
 } 
__p+='\n          ';
 if(office && office.details && office.details.name) { 
__p+='\n            <span class="font-size-small">\n              <span class="hidden-qv-xs">Brokered by: </span>\n              ';
 if(agent && agent.details.name) { 
__p+='\n                <span class="visible-qv-xs-inline qv-branding-link"> with </span>\n              ';
 } 
__p+='\n              <span class="qv-branding-link" data-label="branding-office-name"> '+
((__t=(office.details.name ))==null?'':__t)+
'</span>\n            </span>\n          ';
 } 
__p+='\n        </div>\n      </div>\n    </div>\n  </div>\n</div>';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/optimization/listing-promo-branding.jst.ejs